import React, { useState, useEffect } from 'react';
import './LanguageSwitch.css';

const LanguageSwitch = () => {
  const [lang, setLang] = useState('en');

  // Check the cookie so it stays on TR if you refresh the page
  useEffect(() => {
    if (document.cookie.includes('googtrans=/en/tr')) {
      setLang('tr');
    }
  }, []);

  const handleToggle = () => {
    const newLang = lang === 'en' ? 'tr' : 'en';
    setLang(newLang);
    
    // Explicitly set the cookie to force Google Translate's state
    if (newLang === 'tr') {
      document.cookie = "googtrans=/en/tr; path=/";
      document.cookie = "googtrans=/en/tr; path=/; domain=" + window.location.hostname;
    } else {
      // Clear all possible local cookies to make sure it completely resets
      document.cookie = "googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      document.cookie = "googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=" + window.location.hostname;
    }

    const select = document.querySelector('.goog-te-combo');
    if (select) {
      // Sometimes setting it back to 'en' briefly forces a hard refresh on the DOM
      select.value = 'en';
      select.dispatchEvent(new Event('change', { bubbles: true }));
      
      if (newLang === 'tr') {
        setTimeout(() => {
          select.value = 'tr';
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }, 50); // tiny delay ensures Google catches the swap
      }
    }
  };

  return (
    // "notranslate" class tells Google Translate to completely ignore this container
    // so it will never turn the word "EN" into "İngilizce" or "TR"
    <div className="global-language-switch notranslate">
      <span className={lang === 'en' ? 'active' : ''}>EN</span>
      <label className="ios-switch">
        <input type="checkbox" checked={lang === 'tr'} onChange={handleToggle} />
        <span className="slider"></span>
      </label>
      <span className={lang === 'tr' ? 'active' : ''}>TR</span>
    </div>
  );
};

export default LanguageSwitch;